/**
 * The primary pill bar's identity in the DOM (ui#1534).
 *
 * The bar is the top-level `<nav>` landmark `nav/normal/NavBar` renders in both auth states — the
 * destination pills, the Personalization toggle, Resources, the theme toggle and the profile menu. Two
 * modules have to name it: the bar stamps {@link NAV_PILL_BAR_ATTR} on itself, and the feature sheet
 * ({@link ../components/FeaturePanel}) hands {@link NAV_PILL_BAR_SELECTOR} to
 * {@link ../components/CardSheet} as the region its OWN controls live in, so a destination pill is not
 * read as a click on the page behind that sheet.
 *
 * A marker rather than either thing the bar already carries, because both are unusable as a rule:
 *
 *  - its accessible name (`nav.primaryAria`) is translator-owned catalog copy, so a DOM rule keyed on it
 *    would mean something different in each locale and silently stop matching on a copy edit;
 *  - its class comes from a CSS module, so the shipped value is a hash rather than a name.
 *
 * And plain `nav` would be broader than the truth. A landmark is the DOM's word for chrome but not only
 * for THIS chrome: `components/ContentArticlePage` wraps its related links in one, and those are page
 * content behind a sheet rather than the controls that drive it.
 *
 * Deliberately import-free, so any module may name the bar without pulling the bar itself — and its own
 * component tree, which reaches the router and MUI — into that module's graph.
 */

/** The attribute `nav/normal/NavBar` stamps on the primary pill landmark, in both auth states. */
export const NAV_PILL_BAR_ATTR = "data-nav-pill-bar";

/** The same marker as a selector, for a DOM rule asking whether a click landed inside the bar. */
export const NAV_PILL_BAR_SELECTOR = `[${NAV_PILL_BAR_ATTR}]`;
